import React from 'react';
import TopicComponent from '../../views/plp/TopicComponent';
import ComponentRegistry from '../../model/ComponentRegistry.js';
import completedTickImg from '../../images/icons/tick_icon_white.png';

export default class ms_TopicComponent extends TopicComponent{
	
	constructor(props){
		super(props);
		this.clickTopic = this.clickTopic.bind(this);
	}

	clickTopic(){
		var me=this;
		if(me.props.topic.topicLocked === false){
			return me.onTopicStart();
		}
	}

	 getTopicBottomSection(){
  	 let me = this;
		let lessonLocked = me.props.topic.topicLocked || false;
		let showCursor='lockcursor';
		if(!lessonLocked){
			showCursor = "showcursor"
		}

	  if(this.props.lessonOnlyMode == true){
		  return(
					<div className="card-body card-bottom text-center lessononlytopic">	
			 		    <div className={"card-link tileLink "+showCursor} onClick={this.clickTopic} data-ga={"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topic.topicName+" - "+this.getLesssonsActionLabel()}>		    		    	
				    		    <h5>
				    		      {(() => {
				    		      	if(me.props.topic.topicLocked === true){
				    		      		return (<i className="material-icons">
													lock
													</i>)
				    		      	}

				    		      	switch (me.props.topic.status) {
				    		          case "COMPLETED":   return this.rb("lesson.watched");
				    		          case "IN_PROGRESS": return this.rb("home.resume");
				    		          default:      return this.rb("home.start");
				    		        }
				    		      })()}
				    		    </h5>
			   		     </div>
			   		</div>
				);
	  }else{
		  return(
					<div className="card-body card-bottom">			      		    
			   		    <div className={"card-link tileLink "+showCursor} onClick={this.clickTopic}  data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topic.topicName+" - "+this.getTestsActionLabel()}>		    		    	
				    		    <h5>
										{(() => {
				    		      	if(me.props.topic.topicLocked === true){
				    		      		return (<i className="material-icons">
													lock
													</i>)
				    		      	}

				    		        switch (me.props.topic.status) {
				    		          case "COMPLETED":   return this.rb("home.completed");
				    		          case "IN_PROGRESS": return this.rb("home.resume");
				    		          default:      return this.rb("home.start");
				    		        }
				    		      })()}
				    		    </h5>
			   		     </div>
			   		</div>
				);
	  }
	
  }

	render() {
	  
    return (  
    		
    		 			<div id="mstopicomp" className={"card "+this.props.selectedGradeLabel}>
			      		  <div className="card-img-top topic text-center" style={{backgroundColor: this.state.boxColor}}>
			      		  		{/* <img className={"bgimg animgif " + ((this.props.topic.status === "COMPLETED" && this.props.lessonOnlyMode == false) ? 'opacityInGif' : '')} src={this.state.imgSrc} /> */}
			      		  	{/* 	{(() => {
				    		        if(this.props.topic.status === "COMPLETED") {
				    		        	if(this.props.lessonOnlyMode == false){
				    		        	 return <img className="topiccompletedIcon" src={completedTickImg} />;				    		       
				    		        	}
				    		        }
				    		      })()}
			      		  		 */}
			      		  		
			      		  </div>
			      			  <div className="card-img-overlay">
			      			    <div className="card-title topic-title">{this.props.topic.topicName}</div>		    			    
			      			  </div>
			      			  {/*marked questions hidden -- kamaraj*/}
			      			  {/*<div className="heading-elements">
			      			  	
			      			  	<nav className="navbar fixed-top navbar-expand-md">
			    	    	            <ul className="navbar-nav mr-auto">			    	             
			    	    	                <li className="nav-item dropdown">
			    	    	                    <div className="float-right" data-toggle="dropdown"><i className="material-icons">more_vert</i></div>
			    	    	                    <div className="clearfix"></div>
			    	    	                    <div className="dropdown-menu">
			    	    	                        <a className="dropdown-item" href="#"><i className="material-icons">star</i> {this.rb("home.markedquestions")}</a>
			    	    	                        <div className="dropdown-divider"></div>
			    	    	                        <a className="dropdown-item" href="#"><i className="material-icons">reply</i> {this.rb("home.share")}</a>
			    	    	                    </div>
			    	    	                </li>
			    	    	            </ul>
			      	            </nav>
			      	
			                  </div>*/}
			      			  <div className="card-body descBody">	    		   
				      		    <p className="card-text">{this.props.topic.topicDescription}</p>
				      		  </div>    
				      		  
			      		 {this.getTopicBottomSection()}
			      		  
			    		</div>
    );
  }


}

ComponentRegistry.register("ms_TopicComponent",ms_TopicComponent);

/*
* Also registering for the users with hm_ prefix
*/
ComponentRegistry.register("hm_TopicComponent",ms_TopicComponent);


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/ms_topiccomponent.js